// extracted by mini-css-extract-plugin
export var accordionGeneric = "accordion-module--accordion-generic--3b8c4";
export var content = "accordion-module--content--0158b";
export var copytext = "accordion-module--copytext--01f2f";
export var opened = "accordion-module--opened--14748";